import { Link } from "react-router-dom";
import { CATEGORY_COLORS, FALLBACK_IMAGE } from "@/data/constants";

const fmtDate = (iso) => {
  if (!iso) return "";
  try {
    return new Date(iso).toLocaleDateString("en-US", { year: "numeric", month: "long", day: "numeric" });
  } catch {
    return "";
  }
};

export const ArticleCard = ({ article, compact = false }) => {
  const color = CATEGORY_COLORS[article.category] || "#0A192F";
  return (
    <Link
      to={`/news/${article.slug}`}
      data-testid={`article-card-${article.id}`}
      className="group block bg-white border border-[#0A192F]/10 overflow-hidden hover:-translate-y-1 transition-transform duration-300"
    >
      <div className="relative overflow-hidden aspect-[16/10]">
        <img
          src={article.image_url || FALLBACK_IMAGE}
          alt={article.title}
          loading="lazy"
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500 ease-in-out"
        />
        <span
          className="absolute top-3 left-3 overline text-white px-3 py-1"
          style={{ backgroundColor: color }}
        >
          {article.category}
        </span>
      </div>
      <div className="p-5">
        <h3
          className={`font-display font-bold tracking-tight text-[#0A192F] group-hover:text-[#8B6D1F] transition-colors ${
            compact ? "text-lg leading-snug" : "text-xl leading-snug"
          }`}
        >
          {article.title}
        </h3>
        {!compact && article.excerpt && (
          <p className="mt-2 text-sm text-[#4A5568] leading-relaxed line-clamp-2">{article.excerpt}</p>
        )}
        <p className="mt-3 overline text-[#4A5568]">{fmtDate(article.created_at)}</p>
      </div>
    </Link>
  );
};

export default ArticleCard;
